// extracted by mini-css-extract-plugin
module.exports = {"mobileLegacy":"Index_mobileLegacy__omV56","desktopSpikex":"Index_desktopSpikex__9cbCb"};